<!-- eslint-disable vue/no-v-for-template-key --->
<template>
    <div class="row">
        <!-- style => class -->
        <template v-for="child in children" :key="child.vmId">
            <component :is="getElementComponent(child)" :data="child" :name="(child ?? {}).vmId" :style="childStyle(child)" :view-only="viewOnly" />
        </template>
    </div>
</template>
<script lang="ts">
import { defineComponent, computed, inject } from "vue";
import { usePageStore } from "../pageState/store";
import { BaseElementDefBase } from "../elements/BaseElementDef";
interface Props {
    childrenIds: string[] | BaseElementDefBase[];
    viewOnly: boolean;
    forceNonLive?: boolean;
}
export default defineComponent({
    props: ["childrenIds", "viewOnly", "forceNonLive"],
    setup(props: Props) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const getElementComponent = inject("getElementComponent") as (s: any) => any;
        const pageStore = usePageStore();

        const children = computed(() => {
            return props.childrenIds
                .map(id => {
                    const element = pageStore.getElementByVmId(id);
                    if (element) {
                        element.forceNonLive = props.forceNonLive;
                    }
                    return element;
                })
                .filter(i => (showChanges.value ? true : i?.isBase !== true));
        });
        const showChanges = computed(() => {
            return pageStore.showChanges;
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const childStyle = (child: any) => {
            if (!showChanges.value) {
                return {};
            }
            const baseChangeType = child.baseChangeType();
            if (baseChangeType == null) {
                return {};
            }
            if (baseChangeType == "new" || baseChangeType == "deleted") {
                const parentChangeType = ""; // TODO this.$parent != null && this.$parent.data != null && this.$parent.data.baseChangeType != null ? this.$parent.data.baseChangeType() : null;
                if (parentChangeType == baseChangeType) {
                    return {};
                }
            }
            return {
                "min-height": "5px",
                "border-style": "dashed",
                "border-width": "2px",
                "border-color": baseChangeType == "changed" ? "blue" : baseChangeType == "deleted" ? "red" : baseChangeType == "new" ? "green" : "black",
            };
        };

        return {
            children,
            getElementComponent,
            childStyle,
        };
    },
});
</script>
